export default {
  genres: {},
  years: {}
};
